/**
 * Certificate Finder tool. Utilizes Drupal's JSON:API, JSON:API Include, and
 * JSON:API Extras to configure data fetching directly from the back-end.
 * Autocomplete functionality provided by jQuery UI Autocomplete library
 * and sourced with all published Product titles.
 *
 * @author Todd Miller <github.com/Toddses>
 */

(function ($, once) {
  'use strict';

  const titles = [];
  let $closer;
  let $input;
  let $list;
  let $noresults;
  let $spinner;

  Drupal.behaviors.initializeCertificateFinder = {
    attach: (context) => {
      once('initializeCertificateFinder', 'html').forEach(function (element) {
        initialize();
      });
    },
  };

  /**
   * Grab all node titles for the given URL. Returns the promise.
   */
  function fetchPages(url) {
    return jsonApiRequest(url).then((doc) => {
      doc.data.forEach((item) => {
        titles.push(item.title);
      });

      // Results are paginated, so must be sure to check for and fetch
      // another page.
      if (doc.links.hasOwnProperty('next')) fetchPages(doc.links.next.href);
    });
  }

  /**
   * Actions to take when the user selects an option in the autocomplete box.
   */
  function handleSelect(e, ui) {
    const title = ui.item.value;

    // Clean up and enable the spinner while we fetch the relevant certificates.
    $list.empty();
    $noresults.removeClass('is-active');
    $spinner.addClass('is-active');

    // Grab the product based on title, and include the needed
    // entity references for easy output. Using JSON:API Include module
    // simplifies the api response.
    jsonApiRequest(
      `/jsonapi/node/product?filter[title][value]=${title}&include=field_certificates.field_literature_document.field_media_document`
    ).then((doc) => {
      if (doc.data[0].field_certificates.length)
        $list.append(parseCertificates(doc.data[0].field_certificates));
      else $noresults.addClass('is-active');

      $closer.addClass('is-active');
      $spinner.removeClass('is-active');
    });
  }

  /**
   * Cache elements, attach event listeners, fetch data and attach autocomplete.
   */
  function initialize() {
    $closer = $('#cert-list-closer');
    $input = $('#cert-list-box');
    $list = $('#cert-list');
    $noresults = $('#noresults');
    $spinner = $('#spinner');

    $closer.on('click', reset);

    fetchPages(
      '/jsonapi/node/product?fields[node--product]=title&sort=title'
    ).then(() => {
      $('#cert-list-box').autocomplete({
        source: titles,
        select: handleSelect,
      });
    });
  }

  /**
   * Make a request to Drupal's JSON:API using Javascript's Fetch API.
   * For the promises, yo.
   */
  function jsonApiRequest(url) {
    return fetch(url)
      .then((resp) => {
        return resp.ok ? resp.json() : Promise.reject(resp.statusText);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  /**
   * Parses the JSON response for the certificates field and returns a friendly HTML list.
   */
  function parseCertificates(certs) {
    const $html = $('<ul></ul>');
    certs.forEach((item) => {
      $html.append(
        `<li>${item.title}<a href="${item.field_literature_document.field_media_document.uri.url}" target="_blank" aria-label="download certificate"></a></li>`
      );
    });

    return $html;
  }

  /**
   * Resets everything back to square one.
   */
  function reset() {
    $closer.removeClass('is-active');
    $input.val('');
    $input.focus();
    $list.empty();
    $noresults.removeClass('is-active');
  }
})(jQuery, once);
